import { buildExcelWorkbook } from "./excel";
import type { SimulationExportInput } from "./report";
import { buildSimulationReport } from "./report";
import { buildWordBlob } from "./word";

export type ExportFormat = "xlsx" | "docx";

const XLSX_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

/** Génère le fichier dans le navigateur, sans appel au serveur, puis le télécharge. */
export async function exportSimulation(format: ExportFormat, input: SimulationExportInput) {
	const report = buildSimulationReport(input);
	const blob = format === "xlsx" ? new Blob([await buildExcelWorkbook(report)], { type: XLSX_TYPE }) : await buildWordBlob(report);
	const url = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.download = `${report.fileName}.${format}`;
	document.body.appendChild(link);
	link.click();
	link.remove();
	window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
